import { create } from "zustand";

const useDownloadAppPopupStore = create((set) => ({
  show: false,
  setShow: (value) => set({ show: value }),
}));

export default useDownloadAppPopupStore;
